import styled from "styled-components";

import { fontSizes } from "../../shared/styles/typography";

export const Body = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 40px;
`;

export const FaqCard = styled.div`
  background: var(--color-surface, #fff);
  border: 1px solid var(--color-border, #e8eaf0);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
`;

export const QuestionButton = styled.button`
  width: 100%;
  border: none;
  background: transparent;
  padding: 16px;
  cursor: pointer;
  text-align: left;
`;

export const QuestionRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const QuestionText = styled.span`
  flex: 1;
  font-size: ${fontSizes.base}px;
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-title, #1e293b);
  line-height: 1.4;
`;

export const Answer = styled.div`
  padding: 0 16px 16px;
  font-size: ${fontSizes.base}px;
  line-height: 1.55;
  color: var(--color-text-secondary, #64748b);
  white-space: pre-wrap;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 48px 20px;
  color: #6e6a7c;

  svg {
    margin-bottom: 16px;
    opacity: 0.5;
  }

  h2 {
    font-size: ${fontSizes.xl}px;
    font-weight: var(--font-weight-semibold);
    color: var(--color-text-title, #1e293b);
    margin: 0 0 8px;
  }

  p {
    margin: 0;
    font-size: ${fontSizes.sm}px;
    line-height: 1.5;
  }
`;
